import { Button, ButtonRole, ButtonTargetKind } from "@components/Button";
import { Icon, IconSize, IconDisplay } from "@components/Icon";
import styled from "@emotion/styled";
import React from "react";

import { colorCssVars, lightBgThemeCss } from "src/theme/color";
import { spacing } from "src/theme/spacing";
import { FontWeight, TextSize, textSizeCss } from "src/theme/text";
import { getWindow } from "src/utility/window";

export const HighlightedSection = styled.blockquote`
  padding-left: ${spacing.oldM};
  border-left: 4px solid var(${colorCssVars.accent.large});
  font-weight: ${FontWeight.BOLD};

  > :not(:last-child) {
    margin-bottom: ${spacing.oldM};
  }
`;

export const TopLink: React.FCC<{ "data-tname": string }> = ({
  "data-tname": dataTname,
}) => (
  <Button
    aria-label="Scroll to top"
    data-tname={dataTname}
    role={ButtonRole.UNSTYLED}
    onClick={{
      kind: ButtonTargetKind.FUNCTION,
      action: () => {
        const window = getWindow();
        if (!window) {
          return;
        }
        if (window?.document.location.hash) {
          window.history.pushState({}, window?.document.title, " ");
        }
        window.scroll({ top: 0, behavior: "smooth" });
      },
    }}
  >
    <Icon
      iconImport={() => import("@components/Icon/icons/TopIcon")}
      size={IconSize.MEDIUM}
      display={IconDisplay.ACCENT}
    />
  </Button>
);

export const Table = styled.table`
  ${lightBgThemeCss};

  th {
    padding: ${spacing.xs};
    border: 1px solid var(${colorCssVars.text.secondary});
  }

  td {
    padding: ${spacing.xs};
    border: 1px solid var(${colorCssVars.text.secondary});
  }

  small {
    ${textSizeCss[TextSize.xxs]}
  }
`;
